<template>
  <div>
    <a v-b-modal.modal-2>Terms of Use</a>

    <b-modal id="modal-2" size="xl" title="Terms of Use">
      <appTermsOfUse></appTermsOfUse>
    </b-modal>
  </div>
</template>
<script>
import appTermsOfUse from '../../views/Common/TermsOfUse.vue'
export default {
  components: {
    appTermsOfUse
  }
}
</script>